const doc = [({"da":({"js":({"block_ui":({"please_wait":"Vent venligst..."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;